import React, { useState, useEffect} from 'react'
import NavigationLayout from '../../Components/NavigationLayout'
import { Page } from '@shopify/polaris'
import VouchersTable from './VouchersTable'
import axios from "../../Assets/Lib/axios";
import Cookies from "js-cookie";
import {VERIFICATION_TYPES} from "../../global";

const VouchersList = () => {
    const [successVouchers, setSuccessVouchers] = useState([]);

    const getVouchersList = () => {
        const accreditationTypeId = Cookies.get("accreditation_type_id");
        axios.get(`admin/v1/verification-code/${accreditationTypeId}`, {
            params : {
                type_ids: [
                    VERIFICATION_TYPES.APPLICATION_VERIFICATION_SUBMISSION,
                    VERIFICATION_TYPES.APPLICATION_VERIFICATION_SUBMISSION_LNG,
                ]
            }
        })
            .then((res) => {
                const response = res?.data;
                setSuccessVouchers(response);
            }).catch((err) => {
                console.log("error",err)
            }).finally(() => { });
    }

    useEffect(() => {
        getVouchersList();
    }, []);
    return (
        <NavigationLayout>
            <Page fullWidth divider primaryAction={{
                content: <p style={{ color: "white" }}>Upload Verification Code</p>,
                url: "/admin/upload-verification-code/add",
            }}>
                {/* Voucher Table */}
                {
                    successVouchers.length === 0 ? (
                        <>
                            <p>No successful vouchers found.</p>
                        </>
                    ) : (<VouchersTable vouchers={successVouchers} tabelTitle="Success Vouchers" />)
                }
            </Page>
        </NavigationLayout>
    )
}

export default VouchersList;